import React from 'react';
import SIcon from './SIcon';
import { faMagnifyingGlassChart } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faMagnifyingGlassChart} fa />;

export default Icon;